export const START_PROJECT_CLICK = 'Start a Project.click';
export const EMAIL_CLICK = 'Email.click';
export const CONTACT_FORM_SUBMIT_SUCCESS = 'Contact Form.submit_success';
export const CONTACT_FORM_SUBMIT_ERROR = 'Contact Form.submit_error';

export default [
  START_PROJECT_CLICK,
  EMAIL_CLICK,
  CONTACT_FORM_SUBMIT_SUCCESS,
  CONTACT_FORM_SUBMIT_ERROR
];
